<template>
  <div id="drawer" :class="{ active: isDrawerActive }" @click.prevent="toggle">
    <slot>
      <button type="button" class="drawerButton" title="Menu">
        <span class="textRotateLeft">Paths</span>
      </button>
    </slot>
  </div>
</template>

<script>
import { replaceStore, replaceMutations } from '@state/helpers'

export default {
  // data: () => ({
  //     isdrawerActive: false
  // }),
  computed: {
    isDrawerActive() {
      return replaceStore.isNavOpen
    },
  },
  methods: {
    toggle() {
      replaceMutations.toggleNav()
    },
  },
}
</script>

<style lang="scss">
@import '@design';

.drawerButton {
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 50;
  display: block;
  width: 50px;
  height: 300px;
  font-size: 1.2rem;
  font-weight: bold;
  color: $white;
  text-align: center;
  text-transform: uppercase;
  pointer-events: all;
  cursor: pointer;
  background-color: rgba(5, 30, 47, 0.75);
  border: 0;
  border-radius: 0;
  transition: left 0.6s ease-out 0.5s;
  transition-delay: 0.4s;
  transform: translateY(-50%);
  clip-path: polygon(
    0% 0,
    0 0%,
    0 0%,
    100% 0,
    100% calc(100% - 40px),
    calc(100% - 40px) 100%,
    0 100%,
    0 0
  );
}

.active .drawerButton {
  left: -50px;
}
</style>
